export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Al completar la operación, se cerrará. Los fondos internos se transferirán al usuario."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de que desea completar la operación?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sí, completar"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No, mantener activa"])}
}